module.exports = "\n<app-paremployee-navtab></app-paremployee-navtab>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/paremployee-routes/paremployee-routes.component.html
// module id = ./src/app/components/paremployee-routes/paremployee-routes.component.html
// module chunks = main